// This file is generated by a script. Do not edit this file directly.
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.YT = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.YT = void 0;
  _react = _interopRequireWildcard(_react);
  var React = _react;
  function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
  function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var YT = _exports.YT = function YT(props) {
    return /*#__PURE__*/React.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/React.createElement("g", {
      clipPath: "url(#prefix__a)"
    }, /*#__PURE__*/React.createElement("path", {
      fill: "red",
      d: "m10.444 16.868-4.091-.075c-1.325-.026-2.653.026-3.952-.244C.426 16.145.286 14.166.14 12.506a28.4 28.4 0 0 1 .257-7.024c.215-1.299 1.062-2.073 2.37-2.158 4.417-.306 8.863-.27 13.27-.127.465.013.934.085 1.393.166 2.266.398 2.32 2.64 2.468 4.528a25.7 25.7 0 0 1-.196 5.719c-.224 1.568-.654 2.883-2.467 3.01-2.272.166-4.492.3-6.77.258 0-.01-.013-.01-.02-.01M8.04 12.897c1.712-.983 3.391-1.95 5.094-2.927-1.716-.983-3.392-1.95-5.094-2.926z"
    })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
      id: "prefix__a"
    }, /*#__PURE__*/React.createElement("path", {
      fill: "#fff",
      d: "M0 0h20v20H0z"
    }))));
  };
});
